import React, { useMemo } from 'react';
import IntlMessages from 'util/IntlMessages';

import styles from './styles.module.less';
import { GLOSSARY_ITEMS } from './constants';
import generalStyle from '../../styles.module.less';

const COLUMN_COUNT = 4;

export default function GlosaryAbreviations() {
  const columns = useMemo(() => {
    const n = GLOSSARY_ITEMS.length;
    if (n === 0) {
      return Array.from({ length: COLUMN_COUNT }, () => []);
    }
    const perColumn = Math.ceil(n / COLUMN_COUNT);
    return Array.from({ length: COLUMN_COUNT }, (_, i) =>
      GLOSSARY_ITEMS.slice(i * perColumn, (i + 1) * perColumn),
    );
  }, []);

  return (
    <div className="gx-w-100">
      <p className={`${generalStyle.titleDt} ${styles.glosarySectionTitle}`}>
        <IntlMessages id="work.direction.glosary.abreviation" />
      </p>
      <div className={styles.glosaryContent}>
        {columns.map((column, colIndex) => (
          <div key={`column-${colIndex}`}>
            {column.map((item, itemIndex) => (
              <p key={`item-${colIndex}-${itemIndex}`}>
                <span>{item.short}:</span> {item.label}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
